import { AvatarToken, IssueLabelToken, Token } from '@primer/react';
import * as React from 'react';
export default {
  AvatarToken,
  IssueLabelToken,
  Token,
  React
};